import styled from "styled-components";
import {Card, Tabs} from "antd";

export const HeaderText = styled.span`
    margin-left: 10px;
`;
export const PasswordCard = styled(Card)`
    /* margin-top: 20px;   */
`;

export const StyledCard = styled(Card)`
    background-color: white;
    border: none;
`;

export const StyledTabs = styled(Tabs)`
    .ant-tabs-content {
        background-color: white;
        border: 1px solid #aef001;
        border-top: 1px solid #aef001;
        padding: 16px;
        border-radius: 10px;
    }

    .ant-tabs-tab {
        background-color: white;
        border: none;
        margin-right: 24px;
        border-bottom: 1px solid #d9d9d9;
    }

    .ant-tabs-tab-active {
        background-color: white;
        border-bottom: none;
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: green !important;
    }

    .ant-tabs-ink-bar {
        background-color: green !important;
    }

    .ant-tabs-nav {
        border-bottom: none;
    }
`;

export const ProfileContainer = styled.div`
    background-color: white;
    border: none;
    padding: 20px;
    border-radius: 10px;
`;
